<template>
  <transition name="op">
    <div class="backdrop" v-if="openDrawer">
      <transition name="slide" appear>
        <div
          class="drawer"
          v-if="openDrawer"
          @click="reset"
          v-on-clickaway="away"
        >
          <div class="drawer-header">
            <h4 class="section-title">{{ name }}</h4>
            <a class="close" @click="open = false">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="times"
                class="svg-inline--fa fa-times fa-w-11"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 352 512"
              >
                <path
                  fill="currentColor"
                  d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                />
              </svg>
            </a>
          </div>
          <span class="empty" v-if="data.item_count <= 0">{{
            this.$translations.cart.empty
          }}</span>
          <div class="items">
            <item v-for="item in data.items" :key="item.id" v-bind="item" />
          </div>
          <div class="total_price">
            <p>{{ this.$translations.cart.subtotal }}</p>
            <div>
              <p v-if="data.original_total_price == data.total_price">
                {{ $formatMoney(data.total_price) }}
              </p>
              <p class="discounted" v-else>
                <span class="original_price">
                  {{ $formatMoney(data.original_total_price) }}</span
                >
                <span> {{ $formatMoney(data.total_price) }}</span>
              </p>
            </div>
          </div>

          <div v-if="data.items.length > 0" class="terms">
            <div class="checkbox-wrapper">
              <input
                v-model="agreed_terms.status"
                type="checkbox"
                name="conditions"
                id="conditions"
              />
              <a :href="termspage">
                <span> {{ this.$translations.cart.terms_text }} </span>
              </a>
            </div>
            <div class="form-error" v-if="agreed_terms.error">
              {{ this.$translations.cart.terms_error }}
            </div>
          </div>

          <a
            v-if="data.items.length > 0"
            :class="['checkout-btn', { disabled: !agreed_terms.status }]"
            href="/checkout"
            @click.prevent="checkout"
            >{{ this.$translations.cart.checkout }}</a
          >
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import item from "./item.vue";
import { mixin as clickaway } from "vue-clickaway";

export default {
  props: {
    name: { required: false, type: String },
    termspage: { required: false, type: String },
  },
  mixins: [clickaway],
  components: { item },
  data() {
    return {
      token: JSON.parse(localStorage.getItem("openDrawer")),
      agreed_terms: {
        status: false,
        error: false,
      },
    };
  },
  computed: {
    data() {
      return this.$store.getters["cart/data"];
    },
    open: {
      get() {
        return this.$store.getters["cart/open"];
      },
      set(open) {
        this.$store.dispatch("cart/toggleDrawer", open);
        this.getToken();
      },
    },
    openDrawer() {
      return this.token || this.open;
    },
  },
  methods: {
    getToken() {
      const status = localStorage.getItem("openDrawer");
      this.token = JSON.parse(status);
    },
    away() {
      this.open = false;
    },
    checkout() {
      if (this.agreed_terms.status) {
        window.location.href = "/checkout";
      } else {
        this.agreed_terms.error = true;
      }
    },
    reset() {
      clearTimeout(window.timeoutRef);
    },
  },
};
</script>

<style lang="scss" scoped>
.backdrop {
  position: fixed;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  z-index: 12;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(98, 106, 121, 0.65);
  height: 100%;
}

.drawer {
  position: fixed;
  top: 0;
  width: 600px;
  height: 100vh;
  background-color: $white;
  color: $dark-grey;
  z-index: 13;
  padding: 40px 70px;
  right: 0;
  overflow: scroll;

  @include res(tab-p) {
    padding: 20px;
    width: 100%;
  }

  .drawer-header {
    display: flex;
    justify-content: space-between;

    h4 {
      text-transform: uppercase;
    }

    .close {
      cursor: pointer;

      svg {
        width: 18px;
        height: 18px;
      }
    }
  }

  .empty {
    margin: 14px 0;
    display: inline-block;
  }

  .items {
    margin-top: 40px;
  }

  .total_price {
    margin-top: 20px;
    text-align: right;
    text-transform: uppercase;
    font-size: 10px;

    div {
      margin-top: 5px;
      display: block;
      font-size: 18px;

      .discounted {
        display: flex;
        flex-direction: column;
      }
    }

    .original_price {
      text-decoration: line-through;
      font-size: 15px;
    }
  }

  .checkbox-wrapper {
    display: flex;
    align-items: center;
    margin: 13px 0px;

    span,
    a {
      font-size: 13px;
      color: $dark-grey;
    }

    a:hover {
      text-decoration: underline;
    }

    input[type="checkbox"] {
      appearance: none;
      -webkit-appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      border-radius: 2px;
      background: $grey;
      border: 1px solid #d4d7de;
      height: 18px;
      width: 18px;
      outline: none;
      cursor: pointer;
      position: relative;
      margin: 0 16px 0 0;

      @include res(tab-p) {
        padding: 10px;
      }

      &:checked::before {
        position: absolute;
        content: " ";
        background-image: url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='check' class='svg-inline--fa fa-check fa-w-16' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23969BA5' d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'%3E%3C/path%3E%3C/svg%3E");
        background-size: 13px;
        background-repeat: no-repeat;
        font-size: 25px;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        text-align: center;
        background-position: center;

        @include res(tab-p) {
          font-size: 18px;
        }
      }
    }
  }

  .checkout-btn {
    @include button(#ffffff, 15px, 25px);
    background-color: $dark-grey;
    width: 100%;
    margin-top: 50px;

    &::before {
      @include button-hover($bg: #626a79);
    }

    &.disabled {
      background-color: $medium-grey;
    }

    @include res(mobile) {
      position: fixed;
      left: 0;
      bottom: 0;
    }
  }
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.4s linear;
  transition-delay: 300ms;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  right: -500px;
}

.slide-enter-to,
.slide-leave {
  right: 0px;
  opacity: 1;
}

.op-enter-active,
.op-leave-active {
  transition: all 0.2s linear;
}

.op-enter,
.op-leave-to {
  opacity: 0;
}

.op-enter-to,
.op-leave {
  opacity: 1;
}
</style>
